import { CircularProgress } from "@material-ui/core";
import React from "react";
import classes from "./index.module.scss";
import ReCAPTCHA from "react-google-recaptcha";

export function FirstContent(props: { onSubmit: (secuityNo: string, policyNum: string, captchaToken: string) => void }) {
  const [secuityNo, setSecuityNo] = React.useState<string>("");
  const [policyNum, setPolicyNum] = React.useState<string>("");
  const [loadingBtn, setLoadingbtn] = React.useState<boolean>(false);
  const [captchaToken, setCaptchaToken] = React.useState<string>("");

  const goToInvoiceslist = async () => {
    setLoadingbtn(true);
    props.onSubmit(secuityNo, policyNum, captchaToken);

    setLoadingbtn(false);
  };

  return (
    <section className={classes.wrapper}>
      <div className={classes.mainContent}>
        <div className={classes.rightContent}>
          <p>Cảm ơn Quý khách đã đồng hành cùng Prudential!</p>
          <p>Để xem Thông báo tình trạng hợp đồng bảo hiểm, Quý khách vui lòng nhập thông tin:</p>
          <p>1. Nhập 1 số hợp đồng còn hiệu lực của Quý khách với Prudential</p>
          <p>2. Nhập số Chứng minh nhân dân/Căn cước công dân/Hộ chiếu đã đăng ký với Prudential</p>

          <input style={{
            border: '1px'
          }} placeholder="Số hợp đồng *"
            name="name"
            type="text"
            required
            value={policyNum}
            onChange={(e) => setPolicyNum(e.target.value.trim() as string)} />

          <input 
            style={{ border: '1px' }}
            placeholder="Số CMND/CCCD/Hộ chiếu *"
            name="name"
            type="text"
            required
            value={secuityNo}
            onChange={(e) => setSecuityNo(e.target.value.trim() as string)} />

          <ReCAPTCHA sitekey="6Lf9oMwUAAAAAN5Qiq7fqHCXCJ3Ndw63aDDItSsf"
            onChange={(value) => setCaptchaToken(value || "")}
            hl="vi" />

          <div>
            {loadingBtn 
              ? (
                <div className={classes.loadingBtn}>
                  <CircularProgress />
                </div>
              ) 
              : (
              <button
                className={`${classes.button} ConfirmBtn`}
                onClick={() => goToInvoiceslist()}>
                Xác nhận
              </button>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

// const StyledInput = styled.div`
//   .MuiInputBase-root {
//     background-color: #fff;
//   }
// `;
